module.exports = __webpack_public_path__ + "static/media/certiprof_logo.73555ecf.svg";